
import { defineComponent } from 'vue';
import { useAuth } from '@/plugins/Auth';
import ConfigInput from '@/components/ConfigInput.vue';

export default defineComponent({
  setup() {
    const { configured, user } = useAuth();
    return { configured, user };
  },
  components: { ConfigInput },
});
